import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { HelpLink } from '../../../../../components/common/HelpLink';
import { HELP_LINKS } from '../../../../../constants/HelpLinks';
import {
  ClickOrigin,
  useTrackLearnMoreClickAnalytics,
} from '../../../../../utils/hooks/bi/useTrackLearnMoreClickAnalytics';
import { IOuter } from '../../EmptyState.types';
import styles from './UnknownErrorSubtitle.scss';

export const UnknownErrorSubtitle: FC<IOuter> = () => {
  const { trackLearnMoreClick } = useTrackLearnMoreClickAnalytics();

  const handleHelpLinkClick = useCallback(() => {
    trackLearnMoreClick(ClickOrigin.OopsScreen);
  }, [trackLearnMoreClick]);

  const isNewColorsBrandingEnabled = window.isNewColorsBrandingEnabled;

  return (
    <div className={styles.subtitleHolder}>
      <FormattedMessage
        id="empty-state.something-went-wrong-subtitle"
        values={{
          clickHere: (
            <HelpLink
              underline={isNewColorsBrandingEnabled ? 'always' : 'none'}
              article={HELP_LINKS.LEARN_MORE_OOPS_SCREEN}
              size="small"
              onClick={handleHelpLinkClick}
            >
              <FormattedMessage id="empty-state.something-went-wrong-subtitle.click-here" />
            </HelpLink>
          ),
        }}
      />
    </div>
  );
};

export const NewUnknownErrorSubtitle: FC<IOuter> = () => (
  <p className={styles.subtitleNewBrandingStyles}>
    <FormattedMessage id="empty-state.server-error-subtitle" />
  </p>
);
